export default "__VITE_ASSET__BIGWDJtQ__"